import Vue from "vue";
import progress from "vue-multiple-progress";
Vue.use(progress);
